import { render } from "./Page_Popup_List.vue?vue&type=template&id=35929ac4"
import script from "./Page_Popup_List.vue?vue&type=script&lang=js"
export * from "./Page_Popup_List.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__